import Select, { components } from 'react-select'
import { connect } from 'react-redux';
import { ReactComponent as ChevronDown } from '../../../svg/chevron-down.svg'
import Skeleton from 'react-loading-skeleton'
import { pageCustomBills } from '../../../redux/selectors/pagesSelectors'
import { useNavigate } from 'react-router-dom'
import { setCartSelectedBills } from '../../../redux/actions/cartAction'

function CurrencyFilterRow ({
    bills,
    cart,
    pageLoading,
    setCartSelectedBills
}) {
    const DropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <ChevronDown className="icon"/>
        </components.DropdownIndicator>
    )
    const navigate = useNavigate();

    let defaultOptions = {
        value: 'Select',
        label: 'Select'
    }

    if (cart?.selectedCustomBills) {
        defaultOptions.value = cart.selectedCustomBills.id;
        defaultOptions.label = cart.selectedCustomBills.title;
    }

    return (
        <div className="section__row">
            <ul className="filter__list">
                <li className="section__cell filter__item filter__item--currency">
                    {pageLoading ? (
                        <Skeleton
                            containerClassName="filter__selector ml-2"
                            height={32}
                        />
                    ) : (
                        <>
                            <label
                                htmlFor="currencyList"
                                className="filter__label text-5"
                            >
                                Bills
                            </label>
                            <Select
                                id="currencyList"
                                options={bills?.bills?.map((item) => ({
                                    value: item?.id,
                                    label: item?.title,
                                }))}
                                className="filter__selector ml-2"
                                classNamePrefix="filter"
                                isSearchable
                                components={{ DropdownIndicator }}
                                defaultValue={defaultOptions}
                                onChange={(e) => {
                                    const currentBill = bills?.bills?.find((item) => item.id === e.value);
                                    setCartSelectedBills(currentBill);
                                    navigate('/bills/'+currentBill?.id, { replace: false });
                                }}
                                value={defaultOptions}
                            />
                        </>
                    )}
                </li>
            </ul>
        </div>
    )
}
const mapStateToProps = (state) => ({
    bills: pageCustomBills(state)
});

const mapDispatchToProps = (dispatch) => ({
    setCartSelectedBills: (value) => dispatch(setCartSelectedBills(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyFilterRow);


